import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { requestPolarCheckout } from '../lib/requestPolarCheckout';
import { creditPacks } from '../data/creditPricing';
import { trackEvent } from '../utils/analytics';

/**
 * @param {{ packKey: string }} props
 */
function CreditPackBuyButton({ packKey }) {
  const { user } = useAuth();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  async function handleClick() {
    setError(null);
    if (!user) {
      setError('Please sign in to purchase credits.');
      return;
    }
    setBusy(true);
    try {
      const result = await requestPolarCheckout(user, packKey);
      if (result.ok) {
        const pack = creditPacks.find((p) => p.packKey === packKey);
        trackEvent('begin_checkout', {
          pack_name: pack?.name || packKey,
          value: pack?.price,
          currency: 'USD',
        });
        window.location.assign(result.url);
        return;
      }
      setError(result.error);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="credits-buy-wrap">
      <button
        type="button"
        className="btn btn-primary credits-buy-btn"
        onClick={handleClick}
        disabled={busy}
        aria-busy={busy}
      >
        {busy ? 'Loading…' : 'Buy Pack'}
      </button>
      {error && (
        <p className="credits-buy-error" role="alert">
          {error}{' '}
          {!user && (
            <Link to="/login" className="credits-buy-error-link">
              Sign in
            </Link>
          )}
        </p>
      )}
    </div>
  );
}

export default CreditPackBuyButton;
